/**
 * @fileoverview POST handler for the "/:app_group_id/liquid_validation/check_syntax" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdLiquidValidationCheckSyntaxCacheKeys } from "./constants";
import type {
  PostAppGroupIdLiquidValidationCheckSyntaxErrors,
  PostAppGroupIdLiquidValidationCheckSyntaxProps,
  PostAppGroupIdLiquidValidationCheckSyntaxResult,
} from "./types";

export const postAppGroupIdLiquidValidationCheckSyntax = reactQueryMutationAdapter(
  postAppGroupIdLiquidValidationCheckSyntaxCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdLiquidValidationCheckSyntaxErrors>()(
    (
      props: PostAppGroupIdLiquidValidationCheckSyntaxProps
    ): Promise<PostAppGroupIdLiquidValidationCheckSyntaxResult> => {
      return fetch(`/${props.appGroupId}/liquid_validation/check_syntax`, "POST", props, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
